import type { ReactNode } from "react";
import { memo } from "react";
import * as Styled from "./style";
import { NextLink } from "~/components/blocks/common/next-link";
import type { Href } from "~/const/hrefs";

type LinkButtonProps = { children: ReactNode; href: Href };

export const LinkItem = memo(({ children, href }: LinkButtonProps) => (
  <NextLink href={href}>
    <Styled.DivWrapper>
      <div>{children}</div>
      <Styled.IconLinkItem name="arrowRight" color="GRAY900" />
    </Styled.DivWrapper>
  </NextLink>
));

LinkItem.displayName = "LinkItem";
